module.exports = __webpack_public_path__ + "static/blog60-2eb02f23b0c32a6c9e223dbe74b1319f.png";